import ExternalIcon from '@/assets/icons/External.svg';
import { cn } from '@/lib/utils';
import { NavLink } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { getOrganization, OrganizationDto } from '@/service/overview';
import { DOCUMENTATION_URL } from '@/config';
import JenApiPlatformIcon from '@/assets/icons/JenApiPlatform.svg';
import { useDimensions } from '@/hooks/useDimensions';
import { EyeClosedIcon, MenuIcon, ShieldCloseIcon, XIcon } from 'lucide-react';
import Drawer from '../Drawer';
import { useState } from 'react';
import { DefaultNav, ProfileNav } from '../../App';

const Header = ({ className }: { className?: string }) => {
  const { data: userInfo } = useRequest(getOrganization);
  const { isMobileOrPad } = useDimensions();
  const [isLinksDetailShow, setIsDrawerShow] = useState(false);
  return (
    <div className={cn('h-[64px] flex justify-between', className)}>
      {/* <Workspace userInfo={userInfo} /> */}
      <JenApiPlatformIcon />
      {isMobileOrPad ? (
        <>
          <div className="p-4" onClick={() => setIsDrawerShow(true)}>
            <MenuIcon />
          </div>
          <Drawer className="bg-white" side="right" width="100vw" isOpen={isLinksDetailShow} onClose={() => setIsDrawerShow(false)}>
            <div className="w-full h-full flex flex-col relative">
              <XIcon onClick={() => setIsDrawerShow(false)} className=" absolute right-2 top-2 box-content p-[14px]" />
              <div className="w-full h-full  bg-jen-background-primary">
                <JenApiPlatformIcon />
                <div onClick={() => setIsDrawerShow(false)}>
                  <DefaultNav />
                  <ProfileNav />
                  <div className="px-2">
                    <div className="text-jen-content-tertiary font-pressura-mono text-[12px]  py-2 px-2">RESOURCES</div>
                    <div className="py-3 px-2 text-jen-content-tertiary flex justify-between items-center gap-[6px]">
                      <a href={DOCUMENTATION_URL}> Documentation</a>

                      <ExternalIcon fillColor="currentColor" />
                    </div>
                  </div>
                </div>
                {/* <SideBar clickNavigationCallback={() => setIsDrawerShow(false)} /> */}
              </div>
            </div>
          </Drawer>
        </>
      ) : (
        <Account userInfo={userInfo} />
      )}
    </div>
  );
};

export const Avatar = ({ className, name }: { className?: string; name?: string }) => {
  return (
    <div
      className={cn(
        'w-8 h-8 rounded-md bg-jen-background-primary border border-jen-border-primary text-jen-content-tertiary uppercase flex justify-center items-center',
        className,
      )}
    >
      {name?.slice(0, 1)}
    </div>
  );
};

const Account = ({ userInfo }: { userInfo?: OrganizationDto }) => {
  return (
    <div className="p-4 flex gap-1 items-center">
      <div className="flex px-6 gap-6 cursor-pointer">
        <NavLink to={'/'} className={({ isActive }) => cn('text-jen-content-tertiary', { [' text-[#111112]']: isActive })}>
          API Dashboard
        </NavLink>
        <div className=" text-jen-content-tertiary flex items-center gap-[6px]">
          <a href={DOCUMENTATION_URL}> Documentation</a>

          <ExternalIcon fillColor="currentColor" />
        </div>
      </div>

      <NavLink to={'/profile'} className={({ isActive }) => cn('text-jen-content-tertiary', { [' text-[#111112]']: isActive })}>
        Account
      </NavLink>
    </div>
  );
};

export default Header;

// const LinkDetailDrawer = () => {

//   return (
//     <Drawer className="bg-white" side="right" width="100vw" isOpen={isLinksDetailShow} onClose={() => setIsDrawerShow(false)}>
//       <div className="w-full h-full flex flex-col relative">
//         <ShieldCloseIcon onClick={() => setIsDrawerShow(false)} className=" absolute right-2 top-2 box-content p-[14px]" />
//         <div className="w-full h-full  bg-jen-background-primary">
//           123
//           {/* <SideBar clickNavigationCallback={() => setIsDrawerShow(false)} /> */}
//         </div>
//       </div>
//     </Drawer>
//   );
// };
